export const ADMIN = 'admin'
export const USER = 'user'
export const TEST_STATION_ADMIN = 'testStationAdmin'
export const TEST_STATION_USER = 'testStationUser'
export const TENE_ADMIN = 'Authenticated'
